import { render, staticRenderFns } from "./modal-team-invite.vue?vue&type=template&id=b939fcea&"
import script from "./modal-team-invite.vue?vue&type=script&lang=ts&"
export * from "./modal-team-invite.vue?vue&type=script&lang=ts&"
import style0 from "./modal-team-invite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports